import clsx from 'clsx'
import React, { useRef } from 'react'
import { useEffect } from 'react'

import styles from './styles.module.scss'

import { IImageProps } from './Image'

export const BackgroundImage = ({
  src,
  type,
  alt,
  style = {},
  onClick,
  icon,
  round,
  iconGradient,
  id,
  className,
}: IImageProps) => {
  const classes = clsx(styles.container, styles[type], {
    [styles.onClick]: onClick,
    [styles.icon]: icon,
    [styles.round]: round,
    [styles.iconGradient]: iconGradient,
    [styles.backgroundImage]: true,
  })

  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const imageObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const element = entry.target
          element.classList.remove(styles.lazy)
          imageObserver.unobserve(element)
        }
      })
    })

    if (ref.current) {
      imageObserver.observe(ref.current)
    }
  }, [ref.current])

  return (
    <div
      id={id}
      role='img'
      aria-label={alt}
      className={clsx(classes, styles.lazy, className)}
      style={{ ...style, backgroundImage: `url(${src})` }}
      onClick={() => (onClick ? onClick() : {})}
      ref={ref}
    ></div>
  )
}
